module.exports = __webpack_public_path__ + "img/logo.92b75c70.png";